import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCurrentExposure = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .654765,
			d: "M30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30C0 13.4315 13.4315 0 30 0Z",
			fill: "#FFEAF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.2383 32.4218V23.197",
			stroke: "#F7447A",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4762 40.4762H17L30.2381 14L43.4762 40.4762Z",
			stroke: "#F7447A",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.6875 36.0728C31.6875 36.881 31.0465 37.522 30.2383 37.522C29.4301 37.522 28.7891 36.881 28.7891 36.0728C28.7891 35.2645 29.4301 34.6235 30.2383 34.6235C31.0465 34.6235 31.6875 35.2645 31.6875 36.0728Z",
			fill: "#F7447A"
		})
	]
});
export default SvgCurrentExposure;
